import { memo } from "react";

export const OrderlessDetails = memo(function OrderlessDetails() {
  return null;
});
